import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useNavigate, useLocation } from 'react-router-dom';
import { useModalStack } from '../context/ModalStackContext';

const BackButtonHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { closeTopModal, hasOpenModals } = useModalStack();

  useEffect(() => {
    const handleBackButton = async () => {
      await App.addListener('backButton', (data) => {
        // First check if any modals are open
        if (hasOpenModals) {
          closeTopModal();
          return;
        }

        // If no modals, handle navigation
        if (location.pathname === '/') {
          App.exitApp();
        } else {
          navigate(-1);
        }
      });
    };

    handleBackButton();

    return () => {
      App.removeAllListeners();
    };
  }, [location, navigate]);

  return null;
};

export default BackButtonHandler;